import React from "react"
import styled from "styled-components"
import { Row, Col, Card } from "antd"
import Pot from "../../images/pot.png"
import Shipping from "../../images/shipping.png"
import Canimed from "../../images/img_canimed.png"
import Guarantee from "../../images/guarantee.png"
import Gift from "../../images/gift.png"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;
  padding-bottom: 5rem;
  padding-right: 2rem;
  padding-left: 2rem;
  h1 {
    font-size: 46px;
    color: #172315;
    font-weight: 700;
    text-align: center;
  }
  h2 {
    font-size: 22px;
    color: #172315;
    font-weight: 700;
  }
  p {
    font-size: 16px;
    color: #172315;
    font-weight: 500;
  }
  .center-img {
    width: 300px;
    height: auto;
    margin-left: 2rem;
  }

  .circle-white {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    background-color: ${({ theme }) => theme.colors.white};
    border: 2px solid #5a8d52;

    & img {
      position: absolute;
      width: 40px;
      top: 14px;
      left: 14px;
      filter: invert(9%) sepia(53%) saturate(415%) hue-rotate(65deg)
        brightness(98%) contrast(92%);
    }
  }

  .circle {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    background-color: ${({ theme }) => theme.colors.secondary};
    border: 2px solid #5a8d52;

    & img {
      position: absolute;
      width: 40px;
      top: 14px;
      left: 14px;
      filter: brightness(0) invert(1);
    }
  }

  .left-padding {
    padding-left: 1rem;
  }
  .card-inner {
    border-radius: 12px;
    width: 450px;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding-right: 1rem;
    padding-left: 1rem;
    .card-inner {
      border-radius: 12px;
      width: 450px;
    }
    h2 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
    h1 {
      font-size: 26px;
    }
  }
  ${({ theme: { down, breakpoints } }) => down("400px")} {
    padding-right: 0rem;
    padding-left: 0rem;
    .card-inner {
      border-radius: 12px;
      width: 400px;
    }
  }
`

const AdvantagesSection = () => {
  return (
    <StyledSection>
      <h1>Ananda Advantages</h1>
      <Row gutter={[32, 16]}>
        <Col lg={24} xl={8}>
          <Card className="card-inner">
            <Row>
              <Col span={5}>
                <div className="circle-white">
                  <img src={Pot} alt="pot" />
                </div>
              </Col>
              <Col span={19}>
                <h2>100% Organic</h2>
                <p>
                  When an unknown printer took a galley of type and scrambled
                </p>
              </Col>
            </Row>
          </Card>
          <Card className="card-inner">
            <Row>
              <Col span={5}>
                <div className="circle">
                  <img src={Shipping} alt="shipping" />
                </div>
              </Col>
              <Col span={19}>
                <h2>Free Shipping</h2>
                <p>
                  When an unknown printer took a galley of type and scrambled
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col lg={24} xl={8}>
          <img src={Canimed} className="center-img" alt="canimed" />
        </Col>
        <Col lg={24} xl={8}>
          <Card className="card-inner">
            <Row>
              <Col span={5}>
                <div className="circle">
                  <img src={Guarantee} alt="alt" />
                </div>
              </Col>
              <Col span={19}>
                <h2>Certified Products</h2>
                <p>
                  When an unknown printer took a galley of type and scrambled
                </p>
              </Col>
            </Row>
          </Card>
          <Card className="card-inner">
            <Row>
              <Col span={5}>
                <div className="circle">
                  <img src={Gift} alt="alt" />
                </div>
              </Col>
              <Col span={19}>
                <h2>Bonus System</h2>
                <p>
                  When an unknown printer took a galley of type and scrambled
                </p>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </StyledSection>
  )
}

export default AdvantagesSection
